var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminProductsSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true,
      forceTab: "wines"
    }
  }) : _vm._e(), _c("ProductDetails", {
    staticClass: "content-centered large",
    attrs: {
      idWine: _vm.id,
      type: "wine",
      loggedUserData: _vm.loggedUserData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };